import type { ConceptDef } from '../types';

export const tactBuildings: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-buildings',
  label: 'Expressive Buildings',
  category: 'Expressive',
  description: 'Show a building; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🏠 house' },
      { prompt: '🏫 school' },
      { prompt: '🏥 hospital' },
      { prompt: '🏰 castle' },
      { prompt: '⛪ church' },
      { prompt: '🕌 mosque' },
      { prompt: '🏢 office' },
      { prompt: '🏭 factory' },
    ],
  },
};
